/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./syncronizeHealthStatesDialog.vue?vue&type=template&id=11487c52"
import script from "./syncronizeHealthStatesDialog.vue?vue&type=script&lang=js"
export * from "./syncronizeHealthStatesDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports